import React, { PureComponent } from 'react';
import DateMask from "../../../../Common/Components/Mask/DateMask.jsx"

class TablaRowEdicion extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { cobranza } = this.props;

        let fechaDeIngreso = cobranza.FechaIngreso;
        let usuarioDeIngreso = "LLopez";
        let sucursal = cobranza.Sucursal;
        let origen = cobranza.Origen;
        let cobranzaa = "Lorem Ipsum";
        let fechaUltimaModificacion = cobranza.FechaUltModif;
        let usuarioDeModificacion = "JAguirre";
        let fechaEnvioAdmin = "1810-01-01 00:00:00";

        return (
            <tr>
                <td className="no-padding" colSpan="14">
                    <div>
                        <div className="row">
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Fecha de Ingreso</label>
                            <DateMask fecha={fechaDeIngreso} />
                        </div>
                        <div className="row">
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Usuario de Ingreso</label>
                            <label className="col-md-7">{usuarioDeIngreso}</label>
                        </div>
                        <div className="row">
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Sucursal</label>
                            <label className="col-md-7">{sucursal}</label>
                        </div>
                        <div className="row">
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Origen</label>
                            <label className="col-md-7">{origen}</label>
                        </div>
                        <div className="row">
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Cobranza</label>
                            <label className="col-md-7">{cobranzaa}</label>
                        </div>
                        <div className="row">
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Fecha última modificación</label>
                            <DateMask fecha={fechaUltimaModificacion} />
                        </div>
                        <div className="row">
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Usuario de modificación</label>
                            <label className="col-md-7">{usuarioDeModificacion}</label>
                        </div>
                        <div className="row">
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Fecha envio a Admin</label>
                            <DateMask fecha={fechaEnvioAdmin} />
                        </div>
                    </div>
                </td>
            </tr>);
    }
}

export default TablaRowEdicion;